import theme from 'theme'

export const DEFAULT_POPOVER_PAPER_PROPS = {
  sx: {
    backgroundColor: theme.colors.borderMedium,
    transform: 'translate(24px, -10px) !important',
    pointerEvents: 'auto',
    "html[data-theme='light'] &": {
      backgroundColor: theme.colors.surfaceContainerBackground
    }
  },
  style: {
    width: 'fit-content',
    maxHeight: 300,
    borderRadius: theme.spacing.md
  }
}

export const DEFAULT_POPOVER_PROPS = {
  sx: {
    pointerEvents: 'none',
    '& .MuiPopover-paper': {
      pointerEvents: 'auto'
    }
  }
}
